module.exports = __webpack_public_path__ + "static/media/mugshot.b9d51e0c.jpg";